import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { PensionContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/PensionContributionInstruction";
import { EditIncomeDrawdownInstructionDispatcher } from "../Stores/Variable";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { SubAccountAmendmentInstructionClient } from "../../../../../../Wrap/Api/Apply/SubAccountAmendmentInstruction";
import { ProcessType as ActivityType } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { BankAccount } from "../../../../../../Wrap/Models/Domains/BankAccount/BankAccount";
import { BankAccountsClient } from "../../../../../../Wrap/Api/BankAccounts/BankAccounts";
import { CustomerPensionProtectionClient } from "../../../../../../Wrap/Api/Drawdown/CustomerPensionProtection";
import { StandardRegularDrawdownClient } from "../../../../../../Wrap/Api/Drawdown/StandardRegularDrawdown";
import { StandardRegularDrawdown } from "../../../../../../Wrap/Models/Domains/Drawdown/StandardRegularDrawdown";
import { CustomerPensionProtectionModel } from "../../../../../../Wrap/Models/Domains/Drawdown/CustomerPensionProtectionModel";
import { PensionContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";

export class EditIncomeDrawdownAction {
    public static getInstruction(
        id,
        type,
        hierarchyId,
        subAccountHierarchyId,
        clientId,
        onInstructionLoadedCallback: (result?: PensionContributionModel) => void = () => { }
    ): void {
        const pensionContributionInstruction = new PensionContributionInstructionClient();
        if (CommonHelper.isNullOrEmpty(id)) {
            pensionContributionInstruction
                .post(subAccountHierarchyId, hierarchyId, ActivityType.EditIncomeDrawdown)
                .onSuccess((result) => {
                  
                    const instructionId = result.Result;
                    const model = pensionContributionInstruction.get(instructionId, clientId, "edit");
                    model.onSuccess((result) => {
                        EditIncomeDrawdownInstructionDispatcher.dispatch({
                            actionType: ActionType.Success,
                            payload: result,
                        });
                    

                        onInstructionLoadedCallback(result);
                    });
                });
        } else {
            pensionContributionInstruction.get(id, clientId, null, 
                ).onSuccess((result) => {
                EditIncomeDrawdownInstructionDispatcher.dispatch({
                    actionType: ActionType.Success,
                    payload: result,
                });

                onInstructionLoadedCallback(result);
            });
        }
    }

    public static saveInstruction(from, data: PensionContributionModel, customerId?: number, callback?: (data) => void): void {
        const pensionContributionInstruction = new PensionContributionInstructionClient();
        let promise = pensionContributionInstruction.put(data, customerId,null);
        promise.onSuccess((result) => {
            EditIncomeDrawdownInstructionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
            if (result.Errors != null && result.Errors.length > 0) {
                callback(result.Errors.map((ele) => ele.UserMessage));
            } else {
                callback(result);
            }
        });

        promise.onError((err) => {
            EditIncomeDrawdownInstructionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static submitInstruction(id, data, customerId, claccountId, callback?: VoidFunction): void {
        const client = new SubAccountAmendmentInstructionClient();
        const promise = client.put(id, data, customerId, claccountId);
        promise.onSuccess((result) => {
            if (callback) callback();
        });
    }

    public static deleteInstruction(id, callback?: VoidFunction): void {
        const client = new SubAccountAmendmentInstructionClient();
        const promise = client.delete(id);
        promise.onSuccess((result) => {
            if (callback) callback();
        });
    }

    public static getBankAccounts(hierarchyId: string, callBack: (result: BankAccount[]) => void) {
        const client = new BankAccountsClient();
        const promise = client.get(hierarchyId);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });
    }

    public static getCustomerPensionProtection(
        hierarchyId: string,
        callBack: (result: CustomerPensionProtectionModel) => void
    ) {
        const client = new CustomerPensionProtectionClient();
        const promise = client.get(hierarchyId);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });
    }

    public static getStandardRegularDrawdown(hierarchyId: string, callBack: (result: StandardRegularDrawdown) => void) {
        const client = new StandardRegularDrawdownClient();
        const promise = client.get(hierarchyId);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });
    }
}
